export const listStatus = [
  { textStatus: 'Procesada', valueStatus: 'W' },
  { textStatus: 'Pendiente por procesar', valueStatus: 'P' },
  { textStatus: 'Rechazadas', valueStatus: 'E' },
  { textStatus: 'Gestionado - Sin Fiscalizar', valueStatus: 'G' },
]


export const representation = [
  { textRepresentation: 'Standard', valueRepresentation: 'Standard' },
  { textRepresentation: 'Plus', valueRepresentation: 'Plus' },
]

export const graphicalRepresentationHKA = [
  { textRepresentation: 'co-default-21-propina-80', valueRepresentation: 'Standard' },
  { textRepresentation: 'Personalizada', valueRepresentation: 'Plus' },
]
